
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 bg-black/90 backdrop-blur-sm z-50 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 rounded-xl flex items-center justify-center ml-3 relative overflow-hidden shadow-lg border border-yellow-300/20">
            {/* تصميم فاخر للشعار */}
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-300/30 to-transparent"></div>
            <div className="relative z-10">
              <div className="text-black font-bold text-lg" style={{ fontFamily: 'serif' }}>س</div>
              <div className="absolute -top-1 -right-1 w-2 h-2 bg-white/40 rounded-full"></div>
              <div className="absolute -bottom-1 -left-1 w-1 h-1 bg-white/60 rounded-full"></div>
            </div>
            {/* تأثير لمعان فاخر */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/20 via-transparent to-transparent"></div>
            <div className="absolute top-1 right-1 w-3 h-3 bg-gradient-to-br from-white/30 to-transparent rounded-full blur-sm"></div>
          </div>
          <div>
            <h1 className="text-lg font-bold bg-gradient-to-r from-yellow-400 to-amber-300 bg-clip-text text-transparent" style={{ fontFamily: 'Pacifico, serif' }}>سوم قطر</h1>
            <p className="text-xs text-gray-400">منصة المزادات الرائدة</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3 space-x-reverse">
          <button 
            onClick={() => navigate('/add-listing')}
            className="w-10 h-10 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full flex items-center justify-center shadow-lg border border-yellow-300/20 hover:from-yellow-300 hover:to-amber-400 transition-all duration-200"
          >
            <i className="ri-add-line text-xl text-black"></i>
          </button>
          <button className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center border border-gray-700/50 hover:bg-gray-800 transition-colors">
            <i className="ri-notification-line text-xl"></i>
          </button>
          <button 
            onClick={() => navigate('/auth')}
            className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center border border-gray-700/50 hover:bg-gray-800 transition-colors"
          >
            <i className="ri-user-line text-xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
